import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { DocumentTypes, } from '@debbie/common/dist/documents/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { Panel, Button, FileDropzone } from '../index.js';
import AddDocumentModal from './AddDocumentModal.js';
import DocumentsTable from './DocumentsTable.js';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents/index.js';
import { EINavZip } from '../bespoke/APCOA/EINavZip.js';
import { EUROINCASSO_TENANT_IDS } from '@debbie/common/dist/bespoke/apcoa/index.js';
export const bp = [
    '07fecc4e-138c-4b9d-a998-ea50a222a3b0',
    '23d71dd4-2724-444a-8288-c0b8b3b9083c',
];
export const fogedrekv = ['82887b60-3da8-4b67-a39f-9cc4a78e40e3'];
const getInitialState = () => {
    return {
        pendingDocuments: [],
        visibleForDebtor: false,
        addDocumentModalOpen: false,
        fileName: 'debbie.pdf',
        type: DocumentTypes.OTHER,
        selectedTemplate: null,
    };
};
const Documents = (props) => {
    const dropzoneRef = useRef(null);
    const lang = useSelector((s) => s.lang);
    const documentsLoadable = useDocumentsByReference(props.refId);
    const documents = h.hasData(documentsLoadable) ? documentsLoadable.data : null;
    const [state, setState] = useState(getInitialState());
    const toggleModal = () => setState({ ...state, addDocumentModalOpen: !state.addDocumentModalOpen });
    return (React.createElement(FileDropzone, { onChange: (file) => {
            setState({
                ...state,
                addDocumentModalOpen: true,
                pendingDocuments: [file],
            });
        }, dropzoneRef: dropzoneRef },
        React.createElement(Panel, { header: React.createElement("span", null,
                lang.documents.documents,
                ' ',
                React.createElement(Button, { style: { float: 'right' }, onClick: toggleModal, size: "mini", theme: "secondary", className: "ui-test-2cc0b2a5" }, lang.documents.addDocument)), placeholder: documents && documents.length === 0
                ? lang.documents.noDocuments
                : undefined },
            documents && documents.length !== 0 && (React.createElement(DocumentsTable, { documents: documents, refId: props.refId, role: props.role, name: props.name, case: props.case, connectMappings: props.connectMappings })),
            props.case &&
                EUROINCASSO_TENANT_IDS.includes(props.case.tenantId) &&
                props.case.migratedId && React.createElement(EINavZip, { case: props.case })),
        state.addDocumentModalOpen && documents && (React.createElement(AddDocumentModal, { refId: props.refId, role: props.role, case: props.case, name: props.name, documentState: state, documents: documents, toggleModal: toggleModal, setDocumentState: setState, refIdType: props.refIdType }))));
};
export default Documents;
//# sourceMappingURL=Documents.js.map